import Swiper from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class CollectionTrendingArticles extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-trendingArticleSwiper',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      breakpoints: {
        1024: {
          allowTouchMove: false,
          spaceBetween: 0,
        },
      },
    });
  }
}
